import axios from "axios";

export const BYPASS_ERROR_URLS = [
  `/service/private/v0/configuration/mapping/save`,
];

const apiInstance = () => {
  const api = axios.create({
    baseURL: "",
  });
  // api.interceptors.request.use(async (config) => {
  //   return config;
  // });
  // api.interceptors.response.use(
  //   (response) => {
  //     return response;
  //   },
  //   (error) => {
  //     throw error;
  //   }
  // );
  return api;
};
const nodeClient = apiInstance();

export default nodeClient;
